import {Component, Input, ViewEncapsulation} from '@angular/core';
import {
    MissingAnswers
} from '@modules/activity-edition/core/features/activity-editor-panel/answerTypes';

@Component({
    selector: 'app-activity-edition-preview-missing',
    templateUrl: './activity-edition-preview-missing.component.html',
    encapsulation: ViewEncapsulation.None,
})

export class ActivityEditionPreviewMissingComponent {
    @Input() answersState!: MissingAnswers;

    getTextFromAnswer(answer) {

        if (answer && 'audio' in answer) {
            return { audio: answer.audio, image: answer?.image?.uri };
        } else if (answer && 'image' in answer) {
            return { text: answer.label, image: answer?.image?.uri };
        }
        return { text: '', image: answer?.image?.uri  };
    }

}